export default [
  {
    value: 'residential',
    name: 'Résidentielle'
  },
  {
    value: 'company',
    name: 'Entreprise'
  },
  {
    value: 'pickupPoint',
    name: 'Point relais'
  }
];
